'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _desc, _value, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _ListItem = require('components/ListItem/ListItem');

var _ListItem2 = _interopRequireDefault(_ListItem);

var _Button = require('components/Button/Button');

var _Button2 = _interopRequireDefault(_Button);

var _loadReducer = require('redux/loadReducer');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./ProjectStatsViewerRow.scss');

var ProjectStatsViewerRow = (_class = (_temp = _class2 = function (_PureComponent) {
  (0, _inherits3.default)(ProjectStatsViewerRow, _PureComponent);

  function ProjectStatsViewerRow() {
    (0, _classCallCheck3.default)(this, ProjectStatsViewerRow);
    return (0, _possibleConstructorReturn3.default)(this, (ProjectStatsViewerRow.__proto__ || (0, _getPrototypeOf2.default)(ProjectStatsViewerRow)).apply(this, arguments));
  }

  (0, _createClass3.default)(ProjectStatsViewerRow, [{
    key: 'deleteViewer',
    value: function deleteViewer() {
      var _props = this.props,
          viewer = _props.viewer,
          onDelete = _props.onDelete;

      onDelete({ viewer: viewer });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          className = _props2.className,
          viewer = _props2.viewer,
          projectId = _props2.projectId,
          deleteLoaders = _props2.deleteLoaders;
      var t = this.context.t;

      var loaderKey = (0, _loadReducer.getLoaderKey)([projectId, viewer.userEmail]);
      var isDeleteLoading = deleteLoaders[loaderKey];

      return _react2.default.createElement(
        _ListItem2.default,
        { fullWidth: true, className: (0, _bind2.default)(className) },
        _react2.default.createElement(
          'div',
          null,
          viewer.fullName
        ),
        _react2.default.createElement(
          'div',
          null,
          viewer.userEmail
        ),
        _react2.default.createElement(
          'div',
          { className: styles.actionsCell },
          _react2.default.createElement(
            _Button2.default,
            {
              className: 'btn-text',
              onClick: this.deleteViewer,
              loading: isDeleteLoading,
              small: true
            },
            _react2.default.createElement('i', { className: 'icon-delete', title: t('Delete') })
          )
        )
      );
    }
  }]);
  return ProjectStatsViewerRow;
}(_react.PureComponent), _class2.propTypes = {
  className: _propTypes2.default.string,
  deleteLoaders: _propTypes2.default.object,
  onDelete: _propTypes2.default.func,
  projectId: _propTypes2.default.number,
  viewer: _propTypes2.default.object
}, _class2.contextTypes = {
  t: _propTypes2.default.func
}, _class2.defaultProps = {
  onDelete: _noop3.default,
  viewer: {}
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'deleteViewer', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'deleteViewer'), _class.prototype)), _class);
exports.default = ProjectStatsViewerRow;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Project/ProjectStatsViewerRow/ProjectStatsViewerRow.js
// module id = 2199
// module chunks = 1